// utils/evidenciaPraceUtils.js

// Výpočet total s ohľadom na minimálne poplatky a položky
export function calculateEntryTotal(entry, services) {
  if (entry.itemCount && entry.service && services && services[entry.service]) {
    let total = entry.itemCount * services[entry.service];
    if (entry.service === 'Žiadosť o vrátenie DPH zo zahraničia') {
      total += 15;
    }
    return total;
  }
  // Nové záznamy: počet × cena
  if (entry.minutes != null) {
    let total = (parseFloat(entry.minutes) || 0) * (parseFloat(entry.unitPrice) || 0);
    if (entry.service === 'Žiadosť o vrátenie DPH zo zahraničia') {
      total += 15;
    }
    return total;
  }
  // Staré záznamy (spätná kompatibilita): quantity × unitPrice
  let total = (parseFloat(entry.quantity) || 0) * (parseFloat(entry.unitPrice) || 0);
  if (entry.service === 'Žiadosť o vrátenie DPH zo zahraničia') {
    total += 15;
  }
  return total;
}

// Pomocná funkcia: odpracované hodiny z jedného záznamu (nové aj staré dáta)
// Služby ako 'Účtovníctvo' a 'Fakturácia' nie sú hodinové – vracajú 0
const NON_HOURLY_SERVICES = ['Účtovníctvo', 'Fakturácia'];
export function getEntryHours(entry) {
  if (entry.minutes != null) return (parseFloat(entry.minutes) || 0) / 60;
  if (entry.service && NON_HOURLY_SERVICES.includes(entry.service)) return 0;
  const isHourlyService = entry.service && entry.service.toLowerCase().includes('hod');
  if (isHourlyService) return parseFloat(entry.quantity) || 0;
  // Práca a podobné – odvoď hodiny z total / 50 len ak je total > 0
  const total = parseFloat(entry.total) || 0;
  return total > 0 ? total / 50 : 0;
}

// Súčet total pre zoznam záznamov
export function calculateTotal(entries) {
  return entries.reduce((sum, entry) => sum + entry.total, 0);
}

// Získanie filtrovaných záznamov podľa firmy, mesiaca a vyfakturovania
export function getFilteredEntries(entries, selectedCompany, filterMonth, showInvoiced) {
  return entries.filter(entry => {
    if (selectedCompany && entry.companyName !== selectedCompany) return false;
    if (filterMonth && (entry.workPeriod || entry.date.slice(0, 7)) !== filterMonth) return false;
    if (showInvoiced === 'invoiced' && !entry.invoiced) return false;
    if (showInvoiced === 'not_invoiced' && entry.invoiced) return false;
    // 'all' = bez filtra
    return true;
  });
}

// Normalizácia textu (malé písmená, bez diakritiky, trim)
export function normalizeText(text) {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
        .replace(/[\u0000-\u000F]/g, '') // Odstráni diakritiku
    .trim();
}

// Kapitalizácia názvu firmy (všetko veľkými písmenami)
export function capitalizeCompanyName(text) {
  if (!text) return '';
  return text.trim().toUpperCase();
}
